import moment from 'moment-timezone';

export const FORMAT_TYPE = {
  date: 'date',
  dateTime: 'dateTime',
  timeDate: 'timeDate',
};

export const DATE_FORMAT = 'DD-MMM-YYYY';
export const TIME_FORMAT = 'hh:mm:ss A';
const timezoneAbbreviation = 'UTC';
export function formatDate(date, type = FORMAT_TYPE.date) {
  const utc = moment.utc(date);

  if (!utc.isValid()) {
    return 'invalid date';
  }

  if (type === FORMAT_TYPE.timeDate) {
    return utc.format(`${TIME_FORMAT} ${timezoneAbbreviation} ${DATE_FORMAT}`).toUpperCase();
  }

  if (type === FORMAT_TYPE.dateTime) {
    return utc.format(`${DATE_FORMAT} ${TIME_FORMAT} ${timezoneAbbreviation}`).toUpperCase();
  }

  return utc.format(DATE_FORMAT).toUpperCase();
}
